import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-thumbDown",
  "use": "svgIcon-thumbDown-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svgIcon-thumbDown\"><path d=\"m23.9 13.3c0-1.8-2.6-13.3-4.5-13.3-5 0-10.8 1.9-11.5 3.5 0 0-.7 2.1-.7 4.3s.7 4.8.7 4.8c.4 1.5 4.1 4 5.9 5.2 3.2 2.2 5.5 7 6.2 6.1 2.9-3.5-2-7.9-1.9-8.4.2-.5 5.8-.4 5.8-2.3m-23.8-5.8c0-3 1.1-6 1.1-6h5.6c0 0-1.1 1.9-1.1 6.3 0 3.7 1.1 6.7 1.1 6.7h-5.6c0 0-1.1-2.2-1.1-7\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol